import { render, staticRenderFns } from "./GuideBoardDetail.vue?vue&type=template&id=5ca23e34&"
import script from "./GuideBoardDetail.vue?vue&type=script&lang=js&"
export * from "./GuideBoardDetail.vue?vue&type=script&lang=js&"
import style0 from "./GuideBoardDetail.vue?vue&type=style&index=0&id=5ca23e34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports